import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxButtonModule, DxFormModule } from 'devextreme-angular';
import { ShamShamLogoFullIcon } from 'sham-components/icons';
import { ConfirmEmailManager } from './confirm-email-manager';

@Component({
  selector: 'app-confirm-email',
  imports: [CommonModule, DxFormModule, DxButtonModule, ShamShamLogoFullIcon],
  providers: [ConfirmEmailManager],
  templateUrl: './confirm-email.html',
})
export class ConfirmEmailComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private manager = inject(ConfirmEmailManager);

  loading = signal(true);
  error = signal('');
  success = signal(false);

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    const email = this.route.snapshot.queryParamMap.get('email');

    if (!token || !email) {
      this.error.set('Invalid confirmation link.');
      this.loading.set(false);
      return;
    }

    this.confirm(email, token);
  }

  async confirm(email: string, token: string) {
    const result = await this.manager.confirmEmail(email, token);

    if (result) {
      this.success.set(true);

      setTimeout(() => {
        this.router.navigate(['/signin']);
      }, 2000);
    } else {
      this.error.set('Invalid or expired confirmation link.');
    }

    this.loading.set(false);
  }
}
